"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StatsigHooks_1 = require("./StatsigHooks");
/**
 * A synchronous hook to check the value of an layer.  To ensure correctness, wait for SDK initialization before
 * calling.
 * @param layerName - the name of the layer that has been setup in the Statsig console.
 * @param keepDeviceValue - whether the value returned should be kept for the user on the device for the duration of the experiment
 * @returns an object containing a isLoading flag and the Layer object itself
 */
function default_1(layerName, keepDeviceValue) {
    if (keepDeviceValue === void 0) { keepDeviceValue = false; }
    return (0, StatsigHooks_1.useLayerImpl)(layerName, keepDeviceValue);
}
exports.default = default_1;
